(() => {
    function changeDetail(id, parent) {
        App.Page.get([App.Route('shop.product.details'), id].join('') + '?parentId=' + parent).then(Page => {
            document.querySelector('.js-page-details-container').innerHTML = Page.content;
            App.Layout.refresh();
        });
    }
    $(document).on('change', 'select.js-product-page-subproduct-change', event => {
        if (event.target.value) {
            changeDetail(event.target.value, event.target.dataset.parent || App.Variable('parent'));
        }
    });
})();
